import { render, staticRenderFns } from "./SShareLink.vue?vue&type=template&id=3b501e2d&scoped=true"
import script from "./sShareLink.ts?vue&type=script&lang=ts&external"
export * from "./sShareLink.ts?vue&type=script&lang=ts&external"
import style0 from "./SShareLink.vue?vue&type=style&index=0&id=3b501e2d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b501e2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b501e2d')) {
      api.createRecord('3b501e2d', component.options)
    } else {
      api.reload('3b501e2d', component.options)
    }
    module.hot.accept("./SShareLink.vue?vue&type=template&id=3b501e2d&scoped=true", function () {
      api.rerender('3b501e2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-share-link/SShareLink.vue"
export default component.exports